import Container from "~/components/Container";
import Page from "~/components/Page";
import Section from "~/components/Section";
import Card from "~/components/ui/Card";
import {useSearchParams} from "@solidjs/router";
import RegisterForm from "~/components/form/RegisterForm";
// import {clientOnly} from "@solidjs/start";

export default function RegisterPage() {

    const [searchParams] = useSearchParams()

    // const RegisterForm = clientOnly(() => import("~/components/form/RegisterForm"))

    return (
        <Page
            metaTitle="Create Your Account"
            metaDescription="Register for a Graceful Space Yoga account to purchase class passes and book Vinyasa flow classes in Catshill, Bromsgrove.">
            <Section>
                <Container>
                    <Card>
                        <RegisterForm email={searchParams.email as string | undefined}/>
                    </Card>
                </Container>
            </Section>
        </Page>
    )
}